const findUrlParam = (findParam, url) => {
	const [, paramString] = url.split("?");
	const params = new URLSearchParams(paramString);
	return params.get(findParam) || undefined;
};

export default findUrlParam;
